module.exports = __webpack_public_path__ + "static/OR5-b0c6d26f9428eb7a95513302b01a7a21.jpg";